import { NgModule } from '@angular/core';
import { FiLongPressMobileDirective } from './fi-long-press-mobile.directive';

@NgModule({
    declarations: [FiLongPressMobileDirective],
    exports: [FiLongPressMobileDirective],
})
export class FiLongPressMobileModule {}
